export default __webpack_public_path__ + "static/media/clblit.f2a701ed.png";